export default {
  /**
   * 'a,b,c' -> ['a','b','c']
   */
  getKeys: (str) => {
    return str.split(',')
  },
  /**
   * ['a','b','c'] -> 'a,b,c'
   */
  keysToStr: (arr) => {
    return arr.joni(',')
  },
  orderStatus: {
    'NOT_PAY': '未支付',
    'NOT_CONSUME': '未消费',
    'CONSUMED': '已消费',
    'REFUNDING': '退款中',
    'CANCELED': '已取消',
    'REFUND': '已退款',
    'COMMENTED': '已消费',
    'CLOSED': '已关闭'
  },
  receiveStatus: {
    '0': '',
    '2': '(赊账)'
  },
  payType: {
    'alipay': '支付宝',
    'weixinpay': '微信支付',
    'unkonwn': '暂无'
  },
  tagType: {
    label: '标签基本类型',
    values: {
      1: '普通标签',
      2: '营养标签'
    }
  },
  limitType: {
    label: '标签限制提醒类型',
    values: {
      0: '无限制无提醒',
      1: '限制',
      3: '提醒'
    }
  },
  checkType: {
    label: '标签范围',
    values: {
      1: '单品',
      2: '范围'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/resource.js